import type { FeedItem as FeedItemType } from '@whispers/sdk';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

import { DeckCardImage } from '../DeckCardImage.js';
import { FeedItem } from './FeedItem.js';

type MonthlyPatternFeedItemProps = { item: Extract<FeedItemType, { type: 'monthly_pattern' }> };

export const MonthlyPatternFeedItem = ({ item }: MonthlyPatternFeedItemProps) => {
  const month = dayjs()
    .year(item.pattern.year)
    .month(item.pattern.month - 1)
    .format('MMMM YYYY');
  const cards = item.pattern.cards.toSorted((left, right) => right.count - left.count).slice(0, 3);
  return (
    <FeedItem label="Monthly pattern" occurredAt={item.occurredAt}>
      <p className="text-lg font-medium text-text">{month}</p>
      <p className="mt-1 text-sm text-text-secondary">The cards that visited you most often.</p>
      <p className="mt-3 text-xs text-text-secondary">
        Tap a card to explore its full story and symbolism.
      </p>
      <div className="mt-5 grid grid-cols-3 gap-3">
        {cards.map(({ card, count }) => (
          <Link
            key={card.id}
            to={`/decks/${card.deckSlug}/cards/${card.slug}`}
            className="min-w-0 rounded-lg text-center transition-transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-focus-ring"
          >
            <DeckCardImage
              className="mx-auto w-full max-w-20"
              slug={card.slug}
              deckSlug={card.deckSlug}
              name={card.name}
            />
            <p className="mt-2 truncate text-sm font-medium text-text">{card.name}</p>
            <p className="text-xs text-text-secondary">Drawn {count} times</p>
          </Link>
        ))}
      </div>
    </FeedItem>
  );
};
